import { Checkbox } from '@/components/Checkbox';
import { LabradorComponent } from '@/types/component';

export const LabradorCheckbox: LabradorComponent = ({ type, data, meta }) => {
  return <Checkbox label={data.label} options={data.options} />;
};
